import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Home, Newspaper, BookOpen, Play, Trophy, User } from 'lucide-react';

const navItems = [
  { label: 'Home', href: '/dashboard', icon: Home, authRequired: true },
  { label: 'News', href: '/daily-drop', icon: Newspaper, authRequired: false },
  { label: 'Articles', href: '/deep-dives', icon: BookOpen, authRequired: false },
  { label: 'Videos', href: '/video-vault', icon: Play, authRequired: false },
  { label: 'Ranks', href: '/leaderboard', icon: Trophy, authRequired: false },
  { label: 'Profile', href: '/profile', icon: User, authRequired: true },
];

export default function BottomNav() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  const isActive = (href) => location.pathname === href;

  // Filter items based on auth status
  const visibleItems = navItems.filter(item => 
    !item.authRequired || isAuthenticated
  ).slice(0, 5); // Max 5 items for mobile

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-lg border-t border-border safe-area-bottom" data-testid="bottom-nav">
      <div className="flex items-center justify-around h-16 px-2">
        {visibleItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.href);
          
          return (
            <Link
              key={item.href}
              to={item.href}
              className={`flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors ${
                active 
                  ? 'text-gold' 
                  : 'text-muted-foreground hover:text-foreground'
              }`}
              data-testid={`bottom-nav-${item.label.toLowerCase()}`}
            >
              <Icon className={`w-5 h-5 ${active ? 'text-gold' : ''}`} />
              <span className="text-[10px] font-medium">{item.label}</span>
              {active && (
                <div className="absolute bottom-1 w-1 h-1 bg-gold rounded-full" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
